/**
 * Standalone /legal/:slug page — the same CMS-driven "case file" the landing
 * footer opens, served on its own URL so places that can't host an overlay
 * (the registration Terms checkbox, emails, support replies) can deep-link a
 * document. Closing the file returns to the landing.
 */
import './landing.css';
import { openLegalDoc, closeLegalDoc } from './legal-overlay';
import { fetchCompanyInfo, type CompanyInfo } from '../game/legal-api';

export function renderLegalPage(app: HTMLElement, slug: string, onClose: () => void): () => void {
  app.innerHTML = '';
  const root = document.createElement('div');
  root.id = 'landing-root';
  root.style.background = 'var(--ink, #0b0907)';
  app.appendChild(root);

  let companyOnce: Promise<CompanyInfo | null> | null = null;
  const company = () => (companyOnce ??= fetchCompanyInfo().catch(() => null));
  openLegalDoc(root, slug, company);

  // the overlay owns its close (✕ / Esc / backdrop) — when it leaves the DOM, go home
  const watcher = new MutationObserver(() => {
    if (!root.querySelector('.lglv')) {
      watcher.disconnect();
      onClose();
    }
  });
  watcher.observe(root, { childList: true });

  return () => {
    watcher.disconnect();
    closeLegalDoc(root);
    root.remove();
  };
}
